export default {
  'it-IT': {
    ratings: {
      excellent: 'Eccellente',
      good: 'Buono',
      average: 'Normale',
      poor: 'Scarso',
      bad: 'Pessimo',
    },
    labels: {
      nickname: 'Nickname',
      review: 'Recensione',
      title: 'Titolo',
      voteQualityPriceRatio: 'Giudizio rapporto Qualità/Prezzo',
      voteRate: 'Giudizio complessivo',
      images: 'Immagini',
      optionalImages: 'Immagini <small><em>(facoltative)</em></small>',
      question: 'Domanda',
      answer: 'Risposta',
      description: 'Feedback',
      useExperienceVote: "Giudizio sull'usabilità del sito",
      serviceQualityVote: 'Giudizio sulla qualità del servizio',
      cause: 'Motivazione',
      notes: 'Note',
      returnManner: 'Modalità di spedizione',
      returnType: 'Tipo di reso richiesto',
      category: 'Categoria di reso',
      shippingAddress: {
        firstName: 'Nome',
        lastName: 'Cognome',
        street: 'Indirizzo',
        street2: 'Note corriere',
        zipCode: 'CAP',
        city: 'Città',
        province: 'Provincia',
        country: 'Nazione',
        businessName: 'Ragione sociale',
        shippingTelephone: 'Telefono per il corriere',
        telephone: 'Telefono',
        courierAdditionalNote: 'Note corriere',
        additionalInfo: 'Note',
        firstNamePlaceholder: 'Es. Mario',
        lastNamePlaceholder: 'Es. Rossi',
        streetPlaceholder: 'Es. Via Garibaldi, 35',
        street2Placeholder: 'Es: Interno, scala, note per il corriere',
        courierAdditionalNotePlaceholder:
          'Es: Interno, scala, note per il corriere',
        zipCodePlaceholder: 'Es. 20100',
        cityPlaceholder: 'Es. Roma',
        provincePlaceholder: 'Es. TO',
        businessNamePlaceholder: 'Es. Lordgun srl',
        shippingTelephonePlaceholder: 'Es. +39 123456789',
      },
      billingAddress: {
        firstName: 'Nome',
        lastName: 'Cognome',
        street: 'Indirizzo',
        zipCode: 'CAP',
        city: 'Città',
        province: 'Provincia',
        country: 'Nazione',
        businessName: 'Ragione sociale',
        telephone: 'Telefono',
        additionalInfo: 'Note',
        firstNamePlaceholder: 'Es. Mario',
        lastNamePlaceholder: 'Es. Rossi',
        streetPlaceholder: 'Es. Via Garibaldi, 35',
        zipCodePlaceholder: 'Es. 20100',
        cityPlaceholder: 'Es. Roma',
        provincePlaceholder: 'Es. TO',
        businessNamePlaceholder: 'Es. Lordgun srl',
        wantInvoice: 'Voglio la fattura',
        vatNumber: 'Partita IVA',
        nationalInsuranceNumber: 'Codice fiscale',
        sdi: 'SDI',
        pec: 'PEC',
        vatNumberPlaceholder: 'Es. 01234567890',
        nationalInsuranceNumberPlaceholder: 'Es. AAAAAA99A99A999A',
        sdiPlaceholder: 'Es. 1234abc',
        pecPlaceholder: 'Es. postacertificata@pec.it',
      },
    },
    requiredFields: 'I campi contrassegnati con * sono obbligatori',
    reviewTitlePlaceholder: 'Es: Ottima qualità',
    reviewPlaceholder:
      'Si prega di inserire recensioni che riguardano strettamente il prodotto prestando attenzione ai termini e condizioni (ad es. non è possibile inserire prezzi o riferimenti ad altri concorrenti).',
    questionPlaceholder:
      "Si prega di formulare domande riguardanti l'utilizzo, compatibilità, aspetti tecnici del prodotto che potrebbero essere utili ad altri utenti (NO richieste disponibilità, prossimi arrivi o altri prodotti: per queste c'è la sezione contattaci). Prestare inoltre attenzione ai termini e condizioni (ad es. non è possibile inserire prezzi o riferimenti ad altri concorrenti).",
    answerPlaceholder:
      'Si prega di inserire risposte utili agli altri utenti prestando attenzione ai termini e condizioni (ad es. non è possibile inserire prezzi o riferimenti ad altri concorrenti).',
    feedbackTitlePlaceholder: 'Es: Ottimo servizio',
    feedbackPlaceholder:
      'Si prega di inserire valutazioni riguardanti strettamente il sito ed il servizio. Per gli articoli utilizzare le apposite recensioni nella scheda prodotto.',
    causePlaceholder: '-- seleziona --',
    cancelOrderNotesPlaceholder:
      "Note aggiuntive per l'annullamento dell'ordine",
    returnOrderNotesPlaceholder: "Note aggiuntive per il reso dell'ordine",
    clearRating: 'Azzera il voto',
    imagesButton: 'Allega le tue immagini',
    imagesDropZoneMessage: 'Trascina qui le tue fotografie',
    imagesRequirements: 'Max 3 file con peso non superiore a 5MB',
    imageDeleteMessage: 'Sicuro di voler eliminare {filename}?',
    errors: {
      tooManyFiles:
        'Troppi elementi. Numero massimo di elementi ammesso: {maxFiles}.',
      fileTooLarge:
        '{fileName} troppo grande, la dimensione massima è {maxSize}MB.',
      generic: 'Si è verificato un errore. Si prega di riprovare.',
    },
    isRequired: '{attr} è obbligatorio.',
    isTooLong: 'Il campo {field} è troppo lungo.',
    returnQtyError:
      'Valore non valido. Assicurarsi che la quantità da rendere sia maggiore di zero e non superi la quantità ordinata.',
    imageErrorRequired:
      "Selezionando questa motivazione è obbligatorio caricare almeno un'immagine.",
    charactersNotValid:
      'Sono presenti caratteri non ammessi. È possibile usare solo lettere, numeri e i seguenti caratteri: .:-,',
    emailNotValid: "L'email non è in un formato valido.",
    sdiNotValid: "L'SDI non è in un formato valido.",
    invalidPhone: 'Il numero di telefono inserito non è in un formato valido.',
    mustHaveAtLeastOneBetween:
      'Deve essere presente almeno uno tra i seguenti campi: {optionalField1}, {optionalField2}',
    mustHaveBothFields:
      'Devono essere presenti entrambi i seguenti campi: {field1}, {field2}',
  },
  'fr-FR': {
    ratings: {
      excellent: 'Excellent',
      good: 'Bon',
      average: 'Normal',
      poor: 'Faible',
      bad: 'Mauvais',
    },
    labels: {
      nickname: 'Pseudo',
      review: 'Commentaire',
      title: 'Titre',
      voteQualityPriceRatio: 'Avis rapport Qualité/Prix',
      voteRate: 'Avis global',
      images: 'Images',
      optionalImages: 'Images <small><em>(optionelles)</em></small>',
      question: 'Question',
      answer: 'Réponse',
      description: 'Feedback',
      useExperienceVote: "Avis sur l'utilisation du site",
      serviceQualityVote: 'Avis sur la qualité du service',
      cause: 'Raison',
      notes: 'Notes',
      returnManner: "Mode d'expédition",
      returnType: 'Type de retour souhaité',
      category: 'Catégorie de retour',
      shippingAddress: {
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        street: 'Adresse',
        street2: 'Précisions pour le transporteur',
        zipCode: 'Code postal',
        city: 'Ville',
        province: 'Département',
        country: 'Pays',
        businessName: 'Raison sociale',
        shippingTelephone: 'Numéro de téléphone pour le livreur',
        telephone: 'Numéro de téléphone',
        courierAdditionalNote: 'Précisions pour le transporteur',
        additionalInfo: 'Précisions',
        firstNamePlaceholder: 'Ex: Philippe',
        lastNamePlaceholder: 'Ex: Renault',
        streetPlaceholder: 'Ex: 61, Rue de Paris',
        street2Placeholder:
          'Ex: Bâtiment, étage, précisions pour le transporteur',
        courierAdditionalNotePlaceholder:
          'Ex: Bâtiment, étage, précisions pour le transporteur',
        zipCodePlaceholder: 'Ex: 92190',
        cityPlaceholder: 'Ex: Paris',
        provincePlaceholder: 'Ex: 92',
        businessNamePlaceholder: 'Ex: Lordgun sarl',
        shippingTelephonePlaceholder: 'Ex: (+33)145340564',
      },
      billingAddress: {
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        street: 'Adresse',
        zipCode: 'Code postal',
        city: 'Ville',
        province: 'Département',
        country: 'Pays',
        businessName: 'Raison sociale',
        additionalInfo: 'Précisions',
        firstNamePlaceholder: 'Ex: Philippe',
        lastNamePlaceholder: 'Ex: Renault',
        streetPlaceholder: 'Ex: 61, Rue de Paris',
        zipCodePlaceholder: 'Ex: 92190',
        cityPlaceholder: 'Ex: Paris',
        provincePlaceholder: 'Ex: 92',
        businessNamePlaceholder: 'Ex: Lordgun sarl',
        wantInvoice: "Je désire l'émission d'une facture",
        vatNumber: "Numéro d'identification TVA",
        nationalInsuranceNumber: 'Numéro SIREN',
        sdi: 'SDI',
        pec: 'PEC',
        vatNumberPlaceholder: 'Ex : 404 833 048',
        nationalInsuranceNumberPlaceholder: 'Ex : 321 654 987',
        sdiPlaceholder: 'Ex: 1234abc',
        pecPlaceholder: 'Ex: postacertificata@pec.it',
      },
    },
    requiredFields: "Les champs marqués d'un astérisque (*) sont obligatoires",
    reviewTitlePlaceholder: 'Ex: Excellente qualité',
    reviewPlaceholder:
      'Veuillez écrire des commentaires qui concernent uniquement le produit en suivant les règles de la rubrique "Termes et conditions" (par ex: vous ne pouvez pas faire référence à des concurrents ou à d\'autres prix pratiqués).',
    questionPlaceholder:
      "Veuillez poser des questions qui concernent uniquement l'utilisation, la compatibilité, les aspects techniques du produit et qui pourraient également être utiles aux autres utilisateurs, et NON des questions concernant la disponibilité, les prochains arrivages ou d'autres produits. La rubrique \"Nous contacter\" est prévue à cet effet. Lisez bien les termes et conditions, et veillez à ne pas faire référence à des sites concurrents et à d'autres prix pratiqués.",
    answerPlaceholder:
      "Veuillez donner des réponses qui soient utiles aux utilisateurs en tenant compte des termes et conditions (par ex : il est interdit de faire référence à des sites concurrents et à d'autres prix pratiqués).",
    feedbackTitlePlaceholder: 'Ex: Excellent service',
    feedbackPlaceholder:
      'Merci de laisser des commentaires qui concernent uniquement le site et le service. Pour obtenir un feedback sur les produits, veuillez lire les commentaires affichés dans la fiche produit.',
    causePlaceholder: '-- sélectionner --',
    cancelOrderNotesPlaceholder:
      "Notes additionnelles pour l'annulation de la commande",
    returnOrderNotesPlaceholder:
      'Remarques supplémentaire pour le retour de la commande',
    clearRating: 'Réinitialiser le vote',
    imagesButton: 'Joignez vos images',
    imagesDropZoneMessage: 'Faites glisser vos photos ici',
    imagesRequirements: "Maximum 3 fichiers avec un poids n'excédant pas 5 MB",
    imageDeleteMessage: 'Etes-vous sûr que vous voulez supprimer {filename}?',
    errors: {
      tooManyFiles:
        "Trop d'éléments. Le nombre maximal d'éléments est: {maxFiles}.",
      fileTooLarge:
        '{fileName} trop grand, la dimensione maximale est {maxSize}MB.',
      generic: "Une erreur s'est produite. Veuillez réessayer.",
    },
    isRequired: '{attr} est obligatoire.',
    isTooLong: 'Le champ {field} est trop long',
    returnQtyError:
      'Valeur non valide. Assurez-vous que la quantité à retourner est supérieure à zéro et ne dépasse pas la quantité commandée.',
    imageErrorRequired:
      'En sélectionnant ce motif, il est nécessaire de charger au moins une image.',
    charactersNotValid:
      "Certains caractères ne sont pas autorisés. Il est possible d'utiliser uniquement des lettres, des chiffres et les caractères suivants .:-,",
    emailNotValid: "L'e-mail n'est pas dans un format valide.",
    sdiNotValid: "Le SDI n'est pas dans un format valide.",
    invalidPhone:
      "Le numéro de téléphone introduit n'est pas dans un format valide.",
    mustHaveAtLeastOneBetween:
      'Au moins un des champs suivants doit être présent : {optionalField1}, {optionalField2}',
    mustHaveBothFields:
      'Les deux champs suivants doivent être présents : {field1}, {field2}',
  },
  'es-ES': {
    ratings: {
      excellent: 'Excelente',
      good: 'Bueno',
      average: 'Normal',
      poor: 'Pobre',
      bad: 'Malo',
    },
    labels: {
      nickname: 'Nickname',
      review: 'Comentarios',
      title: 'Título',
      voteQualityPriceRatio: 'Evaluar Calidad/Precio',
      voteRate: 'Evaluación global',
      images: 'Imágenes',
      optionalImages: 'Imágenes <small><em>(opcional)</em></small>',
      question: 'Pregunta',
      answer: 'Respuesta',
      description: 'Feedback',
      useExperienceVote: 'Opinión sobre la usabilidad de la página web',
      serviceQualityVote: 'Opinión sobre la calidad del servicio',
      cause: 'Motivo',
      notes: 'Notas',
      returnManner: 'Método de envío',
      returnType: 'Tipo de devolución solicitado',
      category: 'Categoría de devolución',
      shippingAddress: {
        firstName: 'Nombre',
        lastName: 'Apellido',
        street: 'Dirección',
        street2: 'Nota transporte',
        zipCode: 'Código postal',
        city: 'Ciudad',
        province: 'Provincia',
        country: 'País',
        businessName: 'Razón social',
        shippingTelephone: 'Número de teléfono para la empresa de transporte',
        telephone: 'Número de teléfono',
        courierAdditionalNote: 'Nota transporte',
        additionalInfo: 'Nota',
        firstNamePlaceholder: 'Ej: Mario',
        lastNamePlaceholder: 'Ej: García',
        streetPlaceholder: 'Ej: Calle Alcalá 2',
        street2Placeholder:
          'Ej: interior, escalera, nota para el transportista',
        courierAdditionalNotePlaceholder:
          'Ej: interior, escalera, nota para el transportista',
        zipCodePlaceholder: 'Ej: 20100',
        cityPlaceholder: 'Ej: Madrid',
        provincePlaceholder: 'Ej: Madrid',
        businessNamePlaceholder: 'Ej: Lordgun srl',
        shippingTelephonePlaceholder: 'Ej: (+34) 911234567',
      },
      billingAddress: {
        firstName: 'Nombre',
        lastName: 'Apellido',
        street: 'Dirección',
        zipCode: 'Código postal',
        city: 'Ciudad',
        province: 'Provincia',
        country: 'País',
        businessName: 'Razón social',
        additionalInfo: 'Nota',
        firstNamePlaceholder: 'Ej: Mario',
        lastNamePlaceholder: 'Ej: García',
        streetPlaceholder: 'Ej: Calle Alcalá 2',
        zipCodePlaceholder: 'Ej: 20100',
        cityPlaceholder: 'Ej: Madrid',
        provincePlaceholder: 'Ej: Madrid',
        businessNamePlaceholder: 'Ej: Lordgun srl',
        wantInvoice: 'Quiero factura',
        vatNumber: 'Número CIF',
        nationalInsuranceNumber: 'Número NIF',
        sdi: 'SDI',
        pec: 'PEC',
        vatNumberPlaceholder: 'Ej: 01234567890',
        nationalInsuranceNumberPlaceholder: 'Ej: 01234567890',
        sdiPlaceholder: 'Ej: 1234abc',
        pecPlaceholder: 'Ej: postacertificata@pec.it',
      },
    },
    requiredFields: 'Los campos señalados con * son obligatorios',
    reviewTitlePlaceholder: 'Ej. Óptima calidad',
    reviewPlaceholder:
      'Por favor, realice comentarios en base a las características y uso de un producto prestando atención a los términos y condiciones establecidos (como por ej. no es posible hacer referencia a un precio o a empresas de la competencia).',
    questionPlaceholder:
      'Por favor, realice preguntas en base a la utilidad, compatibilidad y aspectos técnicos del producto que pueden ser útiles para otros usuarios (NO preguntas sobre la disponibilidad, próximas llegadas u otros productos: para estas cuestiones existe la sección "contactanos"). Prestar atención a términos y condiciones establecidos (como por ej. no es posible hacer referencia a un precio o a empresas de la competencia)',
    answerPlaceholder:
      'Por favor, dejar respuestas útiles al resto de usuarios prestando atención a los términos y condiciones establecidos (como por ej. no es posible hacer referencia a un precio o a empresas de la competencia).',
    feedbackTitlePlaceholder: 'Ej. Óptimo servicio',
    feedbackPlaceholder:
      'Por favor, dejar una evaluación únicamente en base al sitio web y al servicio recibido. Para realizar un feedback sobre los productos, utilizar el apartado adecuado en la ficha del producto.',
    causePlaceholder: '-- selecciona --',
    cancelOrderNotesPlaceholder:
      'Notas adicionales para la cancelación del pedido',
    returnOrderNotesPlaceholder:
      'Notas adicionales para la devolución del pedido',
    clearRating: 'Restablecer el voto',
    imagesButton: 'Adjunta las imágenes',
    imagesDropZoneMessage: 'Mueve aquí las fotografías',
    imagesRequirements: 'Máximo 3 archivos con un peso que no supere los 5MB',
    imageDeleteMessage: '¿Estás seguro que lo quieres eliminar {filename}?',
    errors: {
      tooManyFiles:
        'Demasiados elementos. Número máximo de elementos aceptados: {maxFiles}.',
      fileTooLarge:
        '{fileName} demasiado grande, el tamaño máximo es {maxSize}MB.',
      generic: 'Se ha producido un error. Por favor, inténtalo de nuevo.',
    },
    isRequired: '{attr} es obligatorio.',
    isTooLong: 'El campo {field} es demasiado largo.',
    returnQtyError:
      'Valor no válido. Comprueba que la cantidad a devolver es mayor que cero y no supera la cantidad pedida',
    imageErrorRequired:
      'Seleccionando este motivo, es necesario cargar al menos una imagen.',
    charactersNotValid:
      'Hay caracteres que no están permitidos. Solo se pueden utilizar letras, números y los siguientes caracteres: .:-,',
    emailNotValid: 'El correo electrónico no tiene un formato válido.',
    sdiNotValid: 'El SDI no tiene un formato válido.',
    invalidPhone:
      'El número de teléfono introducido no tiene un formato válido.',
    mustHaveAtLeastOneBetween:
      'Al menos uno de los siguientes campos debe estar presente: {optionalField1}, {optionalField2}',
    mustHaveBothFields:
      'Los dos siguientes campos deben estar presentes: {field1}, {field2}',
  },
  'en-GB': {
    ratings: {
      excellent: 'Excellent',
      good: 'Good',
      average: 'Average',
      poor: 'Poor',
      bad: 'Bad',
    },
    labels: {
      nickname: 'Nickname',
      review: 'Review',
      title: 'Title',
      voteQualityPriceRatio: 'Quality/price rating',
      voteRate: 'Overall rating',
      images: 'Images',
      optionalImages: 'Images <small><em>(optional)</em></small>',
      question: 'Question',
      answer: 'Answer',
      description: 'Feedback',
      useExperienceVote: 'Use of website feedback',
      serviceQualityVote: 'Feedback on the quality of service',
      cause: 'Reason',
      notes: 'Notes',
      returnManner: 'Shipment method',
      returnType: 'Type of the return requested',
      category: 'Return category',
      shippingAddress: {
        firstName: 'Name',
        lastName: 'Surname',
        street: 'Address',
        street2: 'Note to courier',
        zipCode: 'Postcode',
        city: 'City',
        province: 'Province',
        country: 'Country',
        businessName: 'Business name',
        shippingTelephone: 'Phone number for the delivery service',
        telephone: 'Phone number',
        courierAdditionalNote: 'Note to courier',
        additionalInfo: 'Note',
        firstNamePlaceholder: 'E.g. John',
        lastNamePlaceholder: 'E.g. Smith',
        streetPlaceholder: 'E.g. 35 Downing Street',
        street2Placeholder: 'E.g. Internal, stair , note to courier',
        courierAdditionalNotePlaceholder:
          'E.g. Internal, stair , note to courier',
        zipCodePlaceholder: 'E.g. DL12 2UL',
        cityPlaceholder: 'E.g. London',
        provincePlaceholder: 'E.g. North Yorkshire',
        businessNamePlaceholder: 'E.g. Lordgun ltd',
        shippingTelephonePlaceholder: 'E.g. (123) 123123',
      },
      billingAddress: {
        firstName: 'Name',
        lastName: 'Surname',
        street: 'Address',
        zipCode: 'Postcode',
        city: 'City',
        province: 'Province',
        country: 'Country',
        businessName: 'Business name',
        additionalInfo: 'Note',
        firstNamePlaceholder: 'E.g. John',
        lastNamePlaceholder: 'E.g. Smith',
        streetPlaceholder: 'E.g. 35 Downing Street',
        zipCodePlaceholder: 'E.g. DL12 2UL',
        cityPlaceholder: 'E.g. London',
        provincePlaceholder: 'E.g. North Yorkshire',
        businessNamePlaceholder: 'E.g. Lordgun ltd',
        wantInvoice: 'I would like an invoice',
        vatNumber: 'VAT number',
        nationalInsuranceNumber: 'ID Number',
        sdi: 'SDI',
        pec: 'PEC',
        vatNumberPlaceholder: 'E.g.: 01234567890',
        nationalInsuranceNumberPlaceholder: 'Your ID Number',
        sdiPlaceholder: 'E.g. 1234abc',
        pecPlaceholder: 'E.g. postacertificata@pec.it',
      },
    },
    requiredFields: 'Fields marked with * are required',
    reviewTitlePlaceholder: 'e.g.: High quality',
    reviewPlaceholder:
      'Fill the field with feedbacks which only concern the product, always keep in mind the terms and conditions (e.g: you cannot refer to competitors and other prices).',
    questionPlaceholder:
      'Your question must be specifically about the use, the compatibility, the technical aspects of the product (do not ask about availability, next arrivals or other products: use the "Contact us" section to do so). Keep in mind the terms and conditions (e.g. you cannot refer to competitors and other prices).',
    answerPlaceholder:
      'Your answers must be useful for the other users. Keep in mind the terms and conditions (e.g: you cannot refer to competitors and other prices).',
    feedbackTitlePlaceholder: 'Ex: Excellent service',
    feedbackPlaceholder:
      'Your feedback must be specifically about the website and the service. To write a feedback about a product, use "reviews" in the product data sheet.',
    causePlaceholder: '-- select --',
    cancelOrderNotesPlaceholder: 'Additional notes for cancelling the order',
    returnOrderNotesPlaceholder: 'Additional notes for the return of the order',
    clearRating: 'Cancel rating',
    imagesButton: 'Attach your images',
    imagesDropZoneMessage: 'Drag here your pictures',
    imagesRequirements: 'Max 3 files under 5MB',
    imageDeleteMessage: 'Are you sure you want to delete {filename}?',
    errors: {
      tooManyFiles:
        'Too many items. Maximum number of items allowed: {maxFiles}.',
      fileTooLarge:
        '{fileName} is too large, maximum file size is {maxSize}MB.',
      generic: 'An error has occurred. Please try again.',
    },
    isRequired: '{attr} is required.',
    isTooLong: 'The field {field} is too long.',
    returnQtyError:
      "Invalid amount. Make sure that the quantity to return is greater than zero and doesn't exceed the ordered quantity",
    imageErrorRequired:
      'If you select this reason, you must upload at least one image.',
    charactersNotValid:
      'There are characters that are not allowed. Only letters, numbers and the following characters can be used: .:-,',
    emailNotValid: 'The email address is not in a valid format.',
    sdiNotValid: 'The SDI is not in a valid format.',
    invalidPhone: 'The phone number entered is not in a valid format.',
    mustHaveAtLeastOneBetween:
      'At least one of the following fields must be present: {optionalField1}, {optionalField2}',
    mustHaveBothFields:
      'Both of the following fields must be present: {field1}, {field2}',
  },
  'en-US': {
    ratings: {
      excellent: 'Excellent',
      good: 'Good',
      average: 'Average',
      poor: 'Poor',
      bad: 'Bad',
    },
    labels: {
      nickname: 'Nickname',
      review: 'Review',
      title: 'Title',
      voteQualityPriceRatio: 'Quality/price rating',
      voteRate: 'Overall rating',
      images: 'Images',
      optionalImages: 'Images <small><em>(optional)</em></small>',
      question: 'Question',
      answer: 'Answer',
      description: 'Feedback',
      useExperienceVote: 'Use of website feedback',
      serviceQualityVote: 'Feedback on the quality of service',
      cause: 'Reason',
      notes: 'Notes',
      returnManner: 'Shipment method',
      returnType: 'Type of the return requested',
      category: 'Return category',
      shippingAddress: {
        firstName: 'Name',
        lastName: 'Surname',
        street: 'Address',
        street2: 'Note to courier',
        zipCode: 'Zip Code',
        city: 'City',
        province: 'Province',
        country: 'Country',
        businessName: 'Business name',
        shippingTelephone: 'Phone number for the delivery service',
        telephone: 'Phone number',
        courierAdditionalNote: 'Note to courier',
        additionalInfo: 'Note',
        firstNamePlaceholder: 'E.g. John',
        lastNamePlaceholder: 'E.g. Smith',
        streetPlaceholder: 'E.g. 887 High St.',
        street2Placeholder: 'E.g. Internal, stair , note to courier',
        courierAdditionalNotePlaceholder:
          'E.g. Internal, stair , note to courier',
        zipCodePlaceholder: 'E.g. 90210',
        cityPlaceholder: 'E.g. New York',
        provincePlaceholder: 'E.g. FL',
        businessNamePlaceholder: 'E.g. Lordgun ltd',
        shippingTelephonePlaceholder: 'E.g. (123) 123123',
      },
      billingAddress: {
        firstName: 'Name',
        lastName: 'Surname',
        street: 'Address',
        zipCode: 'Zip Code',
        city: 'City',
        province: 'Province',
        country: 'Country',
        businessName: 'Business name',
        additionalInfo: 'Note',
        firstNamePlaceholder: 'E.g. John',
        lastNamePlaceholder: 'E.g. Smith',
        streetPlaceholder: 'E.g. 887 High St.',
        zipCodePlaceholder: 'E.g. 90210',
        cityPlaceholder: 'E.g. New York',
        provincePlaceholder: 'E.g. FL',
        businessNamePlaceholder: 'E.g. Lordgun ltd',
        wantInvoice: 'I would like an invoice',
        vatNumber: 'VAT number',
        nationalInsuranceNumber: 'ID Number',
        sdi: 'SDI',
        pec: 'PEC',
        vatNumberPlaceholder: 'E.g.: 01234567890',
        nationalInsuranceNumberPlaceholder: 'Your ID Number',
        sdiPlaceholder: 'E.g. 1234abc',
        pecPlaceholder: 'E.g. postacertificata@pec.it',
      },
    },
    requiredFields: 'Fields marked with * are required',
    reviewTitlePlaceholder: 'e.g.: High quality',
    reviewPlaceholder:
      'Fill the field with feedbacks which only concern the product, always keep in mind the terms and conditions (e.g: you cannot refer to competitors and other prices).',
    questionPlaceholder:
      'Your question must be specifically about the use, the compatibility, the technical aspects of the product (do not ask about availability, next arrivals or other products: use the "Contact us" section to do so). Keep in mind the terms and conditions (e.g. you cannot refer to competitors and other prices).',
    answerPlaceholder:
      'Your answers must be useful for the other users. Keep in mind the terms and conditions (e.g: you cannot refer to competitors and other prices).',
    feedbackTitlePlaceholder: 'Ex: Excellent service',
    feedbackPlaceholder:
      'Your feedback must be specifically about the website and the service. To write a feedback about a product, use "reviews" in the product data sheet.',
    causePlaceholder: '-- select --',
    cancelOrderNotesPlaceholder: 'Additional notes for cancelling the order',
    returnOrderNotesPlaceholder: 'Additional notes for the return of the order',
    clearRating: 'Cancel rating',
    imagesButton: 'Attach your images',
    imagesDropZoneMessage: 'Drag here your pictures',
    imagesRequirements: 'Max 3 files under 5MB',
    imageDeleteMessage: 'Are you sure you want to delete {filename}?',
    errors: {
      tooManyFiles:
        'Too many items. Maximum number of items allowed: {maxFiles}.',
      fileTooLarge:
        '{fileName} is too large, maximum file size is {maxSize}MB.',
      generic: 'An error has occurred. Please try again.',
    },
    isRequired: '{attr} is required.',
    isTooLong: 'The field {field} is too long.',
    returnQtyError:
      "Invalid amount. Make sure that the quantity to return is greater than zero and doesn't exceed the ordered quantity",
    imageErrorRequired:
      'If you select this reason, you must upload at least one image.',
    charactersNotValid:
      'There are characters that are not allowed. Only letters, numbers and the following characters can be used: .:-,',
    emailNotValid: 'The email address is not in a valid format.',
    sdiNotValid: 'The SDI is not in a valid format.',
    invalidPhone: 'The phone number entered is not in a valid format.',
    mustHaveAtLeastOneBetween:
      'At least one of the following fields must be present: {optionalField1}, {optionalField2}',
    mustHaveBothFields:
      'Both of the following fields must be present: {field1}, {field2}',
  },
  'de-DE': {
    ratings: {
      excellent: 'Ausgezeichnet',
      good: 'Gut',
      average: 'Normal',
      poor: 'Nicht so gut',
      bad: 'Sehr schlecht',
    },
    labels: {
      nickname: 'Nickname',
      review: 'Rezension',
      title: 'Titel',
      voteQualityPriceRatio: 'Preis-Leistungsverhältnis',
      voteRate: 'Allgemeine Bewertung',
      images: 'Bilder',
      optionalImages: 'Bilder <small><em>(fakultativ)</em></small>',
      question: 'Frage',
      answer: 'Antwort',
      description: 'Feedback',
      useExperienceVote: 'Meinung zur Benutzerfreundlichkeit der Seite',
      serviceQualityVote: 'Ihre Meinung zur Servicequalität',
      cause: 'Grund',
      notes: 'Anmerkungen',
      returnManner: 'Versandmethode',
      returnType: 'Art der beantragten Retoure',
      category: 'Retouren-Kategorie',
      shippingAddress: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        street: 'Adresse',
        street2: 'Anmerkungen für den Kurier',
        zipCode: 'Postleitzahl',
        city: 'Stadt',
        province: 'Bundesland/Kanton/Region',
        country: 'Land',
        businessName: 'Firmenname',
        shippingTelephone: 'Telefonnummer für den Kurie',
        telephone: 'Telefonnummer',
        courierAdditionalNote: 'Anmerkungen für den Kurier',
        additionalInfo: 'Anmerkungen',
        firstNamePlaceholder: 'Z.B. Peter',
        lastNamePlaceholder: 'Z.B. Müller',
        streetPlaceholder: 'Z.B. Rosengartenstraße 35',
        street2Placeholder: '',
        courierAdditionalNotePlaceholder: '',
        zipCodePlaceholder: 'Z.B. 91783',
        cityPlaceholder: 'Z.B. Berlin',
        provincePlaceholder: 'Z.B.: Wien',
        businessNamePlaceholder: 'Z.B. Lordgun ltd',
        shippingTelephonePlaceholder: 'Z.B. (123) 123123',
      },
      billingAddress: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        street: 'Adresse',
        zipCode: 'Postleitzahl',
        city: 'Stadt',
        province: 'Bundesland/Kanton/Region',
        country: 'Land',
        businessName: 'Firmenname',
        additionalInfo: 'Anmerkungen',
        firstNamePlaceholder: 'Z.B. Peter',
        lastNamePlaceholder: 'Z.B. Müller',
        streetPlaceholder: 'Z.B. Rosengartenstraße 35',
        zipCodePlaceholder: 'Z.B. 91783',
        cityPlaceholder: 'Z.B. Berlin',
        provincePlaceholder: 'Z.B.: Wien',
        businessNamePlaceholder: 'Z.B. Lordgun ltd',
        wantInvoice: 'Ich möchte eine Rechnung erhalten',
        vatNumber: 'USt-IdNr.',
        nationalInsuranceNumber: 'ID Nummer',
        sdi: 'SDI',
        pec: 'PEC',
        vatNumberPlaceholder: 'Z.B.: 01234567890',
        nationalInsuranceNumberPlaceholder: 'Ihre ID Nummer',
        sdiPlaceholder: 'Z.B.: 1234abc',
        pecPlaceholder: 'Z.B.: postacertificata@pec.it',
      },
    },
    requiredFields: 'Mit * gekennzeichnete Felder sind Pflichtfelder',
    reviewTitlePlaceholder: 'Z.B. ausgezeichnete Qualität',
    reviewPlaceholder:
      'Schreiben Sie bitte Rezensionen, die sich lediglich auf den Artikel beschränken. Beachten Sie dabei die Bedingungen (es ist z.B. nicht möglich, Preise oder Hinweise zu Wettbewerbern zu schreiben).',
    questionPlaceholder:
      'Bitte formulieren Sie Fragen zu Benutzung, Kompatibilität und technischen Aspekten, die für andere User nützlich sein könnten (Bitte KEINE Anfragen zu Verfügbarkeit, neuen oder anderen Produkten, dafür ist der Kontaktabschnitt vorgesehen). Beachten Sie bitte die allgemeinen Bestimmungen (z.B. keine Angabe von Preisen oder Konkurrenzfirmen).',
    answerPlaceholder:
      'Bitte tragen Sie für andere User nützliche Antworten ein. Achten Sie dabei bitte auf die allgemeinen Bestimmungen (z.B. keine Angabe von Preisen oder Konkurrenzfirmen).',
    feedbackTitlePlaceholder: 'z.B.: Ausgezeichneter Service',
    feedbackPlaceholder:
      'Bitte beurteilen Sie lediglich unsere Webseite und den Service. Feedbacks zu den Artikeln hinterlassen Sie bitte über den vorgesehenen Abschnitt in der Produktübersicht.',
    causePlaceholder: '-- Auswahl --',
    cancelOrderNotesPlaceholder:
      'Zusätzliche Anmerkungen, um die Bestellung zu stornieren',
    returnOrderNotesPlaceholder:
      'Zusätzliche Hinweise für die Retoure der Bestellung',
    clearRating: 'Setzen Sie die Abstimmung zurück',
    imagesButton: 'Fügen Sie ihre Bilder ein',
    imagesDropZoneMessage: 'Ziehen Sie Ihre Bilder per Drag & Drop hierher',
    imagesRequirements: 'Maximal 3 Bilder, nicht größer als 3 MB.',
    imageDeleteMessage: 'Sind Sie sicher, dass Sie löschen möchten {filename}?',
    errors: {
      tooManyFiles: 'zu viele Objekte. Maximale Anzahl an Objekte: {maxFiles}.',
      fileTooLarge: '{fileName} zu groß, die maximale Größe ist {maxSize}MB.',
      generic: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    },
    isRequired: '{attr} ist ein Pflichtfeld.',
    isTooLong: 'Das Feld ist zu lang.',
    returnQtyError:
      'Ungültiger Wert. Achten Sie darauf, dass die zurückzusendende Menge größer als Null ist und die bestellte Menge nicht übersteigt.',
    imageErrorRequired:
      'Wenn Sie diesen Grund wählen, müssen Sie mindestens ein Bild hochladen.',
    charactersNotValid:
      'Es gibt Zeichen, die nicht erlaubt sind. Es können nur Buchstaben, Zahlen und die folgenden Zeichen verwendet werden: .:-,',
    emailNotValid: 'Die E-Mail-Adresse hat ein ungültiges Format.',
    sdiNotValid: 'SDI hat kein gültiges Format.',
    invalidPhone: 'Die eingegebene Rufnummer hat ein ungültiges Format.',
    mustHaveAtLeastOneBetween:
      'Mindestens eines der folgenden Felder muss vorhanden sein: {optionalField1}, {optionalField2}',
    mustHaveBothFields:
      'Beide der folgenden Felder müssen vorhanden sein: {field1}, {field2}',
  },
  'en-AU': {
    ratings: {
      excellent: 'Excellent',
      good: 'Good',
      average: 'Average',
      poor: 'Poor',
      bad: 'Bad',
    },
    labels: {
      nickname: 'Nickname',
      review: 'Review',
      title: 'Title',
      voteQualityPriceRatio: 'Quality/price rating',
      voteRate: 'Overall rating',
      images: 'Images',
      optionalImages: 'Images <small><em>(optional)</em></small>',
      question: 'Question',
      answer: 'Answer',
      feedback: 'Feedback',
      useExperienceVote: 'Use of website feedback',
      serviceQualityVote: 'Feedback on the quality of service',
      cause: 'Reason',
      notes: 'Notes',
      returnManner: 'Shipment method',
      returnType: 'Type of the return requested',
      category: 'Return category',
      shippingAddress: {
        firstName: 'Name',
        lastName: 'Surname',
        street: 'Address',
        street2: 'Note to courier',
        zipCode: 'Zip code',
        city: 'City',
        province: 'Province',
        country: 'Country',
        businessName: 'Business name',
        shippingTelephone: 'Phone number for the delivery service',
        telephone: 'Phone number',
        courierAdditionalNote: 'Note to courier',
        additionalInfo: 'Note',
        firstNamePlaceholder: 'E.g. John',
        lastNamePlaceholder: 'E.g. Smith',
        streetPlaceholder: 'E.g. 56 Manchester Road',
        street2Placeholder: 'E.g. Internal, stair , note to courier',
        courierAdditionalNotePlaceholder:
          'E.g. Internal, stair , note to courier',
        zipCodePlaceholder: 'E.g. 6020',
        cityPlaceholder: 'E.g. Canberra',
        provincePlaceholder: 'E.g. Queensland',
        businessNamePlaceholder: 'E.g. Lordgun ltd',
        shippingTelephonePlaceholder: 'E.g. (123) 123123',
      },
      billingAddress: {
        firstName: 'Name',
        lastName: 'Surname',
        street: 'Address',
        zipCode: 'Zip code',
        city: 'City',
        province: 'Province',
        country: 'Country',
        businessName: 'Business name',
        additionalInfo: 'Note',
        firstNamePlaceholder: 'E.g. John',
        lastNamePlaceholder: 'E.g. Smith',
        streetPlaceholder: 'E.g. 56 Manchester Road',
        zipCodePlaceholder: 'E.g. 6020',
        cityPlaceholder: 'E.g. Canberra',
        provincePlaceholder: 'E.g. Queensland',
        businessNamePlaceholder: 'E.g. Lordgun ltd',
        wantInvoice: 'I would like an invoice',
        vatNumber: 'VAT number',
        nationalInsuranceNumber: 'ID Number',
        sdi: 'SDI',
        pec: 'PEC',
        vatNumberPlaceholder: 'E.g.: 01234567890',
        nationalInsuranceNumberPlaceholder: 'Your ID Number',
        sdiPlaceholder: 'E.g. 1234abc',
        pecPlaceholder: 'E.g. postacertificata@pec.it',
      },
    },
    requiredFields: 'Fields marked with * are required',
    reviewTitlePlaceholder: 'e.g.: High quality',
    reviewPlaceholder:
      'Fill the field with feedbacks which only concern the product, always keep in mind the terms and conditions (e.g: you cannot refer to competitors and other prices).',
    questionPlaceholder:
      'Your question must be specifically about the use, the compatibility, the technical aspects of the product (do not ask about availability, next arrivals or other products: use the "Contact us" section to do so). Keep in mind the terms and conditions (e.g. you cannot refer to competitors and other prices).',
    answerPlaceholder:
      'Your answers must be useful for the other users. Keep in mind the terms and conditions (e.g: you cannot refer to competitors and other prices).',
    feedbackTitlePlaceholder: 'Ex: Excellent service',
    feedbackPlaceholder:
      'Your feedback must be specifically about the website and the service. To write a feedback about a product, use "reviews" in the product data sheet.',
    causePlaceholder: '-- select --',
    cancelOrderNotesPlaceholder: 'Additional notes for cancelling the order',
    returnOrderNotesPlaceholder: 'Additional notes for the return of the order',
    clearRating: 'Cancel rating',
    imagesButton: 'Attach your images',
    imagesDropZoneMessage: 'Drag here your pictures',
    imagesRequirements: 'Max 3 files under 5MB',
    imageDeleteMessage: 'Are you sure you want to delete {filename}?',
    errors: {
      tooManyFiles:
        'Too many items. Maximum number of items allowed: {maxFiles}.',
      fileTooLarge:
        '{fileName} is too large, maximum file size is {maxSize}MB.',
      generic: 'An error has occurred. Please try again.',
    },
    isRequired: '{attr} is required.',
    isTooLong: 'The field {field} is too long.',
    returnQtyError:
      "Invalid amount. Make sure that the quantity to return is greater than zero and doesn't exceed the ordered quantity",
    imageErrorRequired:
      'If you select this reason, you must upload at least one image.',
    charactersNotValid:
      'There are characters that are not allowed. Only letters, numbers and the following characters can be used: .:-,',
    emailNotValid: 'The email address is not in a valid format.',
    sdiNotValid: 'The SDI is not in a valid format.',
    invalidPhone: 'The phone number entered is not in a valid format.',
    mustHaveAtLeastOneBetween:
      'At least one of the following fields must be present: {optionalField1}, {optionalField2}',
    mustHaveBothFields:
      'Both of the following fields must be present: {field1}, {field2}',
  },
};
